export const lapTimes = [
    { grandPrix: "Bahrain", driver: "Zhou Guanyu", car: "ALFA ROMEO", time: "1:33.996" },
    { grandPrix: "Saudi Arabia", driver: "Max Verstappen", car: "RED BULL RACING ", time: "1:31.906" },
    { grandPrix: "Australia", driver: "Sergio Perez", car: "RED BULL RACING ", time: "1:20.235" },
    { grandPrix: "Azerbaijan", driver: "George Russell", car: "MERCEDES", time: "1:43.370" },
    { grandPrix: "Miami", driver: "Max Verstappen", car: "RED BULL RACING ", time: "1:29.708" },
    { grandPrix: "Monaco", driver: "Lewis Hamilton", car: "MERCEDES", time: "1:15.650" },
    { grandPrix: "Spain", driver: "Max Verstappen", car: "RED BULL RACING ", time: "1:16.330" },
    { grandPrix: "Canada", driver: "Sergio Perez", car: "RED BULL RACING ", time: "1:14.481" },
    { grandPrix: "Austria", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:07.012" },
    { grandPrix: "Great Britain", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:30.275" },
    { grandPrix: "Hungary", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:20.504" },
    { grandPrix: "Belgium", driver: "Lewis Hamilton", car: "MERCEDES", time: "1:47.305" },
    { grandPrix: "Netherlands", driver: "Fernando Alonso", car: "ASTON MARTIN", time: "1:13.837" },
    { grandPrix: "Italy", driver: "Oscar Piastri", car: "MCLAREN", time: "1:25.072" },
    { grandPrix: "Singapore", driver: "Lewis Hamilton", car: "MERCEDES", time: "1:35.867" },
    { grandPrix: "Japan", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:34.183" },
    { grandPrix: "Qatar", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:24.319" },
    { grandPrix: "United States", driver: "Yuki Tsunoda", car: "ALPHATAURI", time: "1:38.139" },
    { grandPrix: "Mexico", driver: "Lewis Hamilton", car: "MERCEDES", time: "1:21.334" },
    { grandPrix: "Brazil", driver: "Lando Norris", car: "MCLAREN ", time: "1:12.486" },
    { grandPrix: "Las Vegas", driver: "Oscar Piastri", car: "MCLAREN ", time: "1:35.490" },
    { grandPrix: "Abu Dhabi", driver: "Max Verstappen", car: "RED BULL RACING", time: "1:26.993" }
].map(lapTime => ({
    ...lapTime,
    car: lapTime.car.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
}));

export type LapTime = {
    grandPrix: string;
    driver: string;
    car: string;
    time: string;
};
